import './LuckyWheel.less';
import React from 'react';
import i18n from '../../common/i18n';
import { Button } from '../button/Button';
import SadEmoticon from '../../icons/SadEmoticon';
import luckyWheelWinImg from './images/lucky-wheel-win.png';
import FreeSpinIcon from 'nike-ui/src/icons/svg/free-spin-icon-sv.svg';
import clsx from 'clsx';
import { LuckyWheelWinType } from './utils/enums';

const getResult = result => {
    switch (result.winType) {
        case LuckyWheelWinType.WIN:
            return {
                title: i18n('luckyWheel.winning.title'),
                subTitle: i18n('luckyWheel.winning.subtitle', `${result.winValue}`),
                butttonText: i18n('luckyWheel.winning.buttonText'),
                resultIcon: <img src={luckyWheelWinImg} alt="lucky-wheel-win" height={130} />
            };
        case LuckyWheelWinType.LOST:
            return {
                title: i18n('luckyWheel.lost.title'),
                subTitle: i18n('luckyWheel.lost.subtitle'),
                resultIcon: <SadEmoticon width={100} />
            };
        case LuckyWheelWinType.REPEAT:
            return {
                title: i18n('luckyWheel.spin-again.title'),
                subTitle: i18n('luckyWheel.spin-again.subtitle'),
                butttonText: i18n('luckyWheel.spin-again.buttonText'),
                resultIcon: <FreeSpinIcon />,
                closable: true
            };
        default:
            return {
                title: i18n('luckyWheel.winning.title'),
                subTitle: i18n('luckyWheel.winning.subtitle', `${result.winValue}`),
                butttonText: i18n('luckyWheel.winning.buttonText'),
                resultIcon: <img src={luckyWheelWinImg} alt="lucky-wheel-win" height={130} />
            };
    }
};
const LuckyWheelResult = ({ result, handleClose, actionButtonClick, onPhone }) => {
    const { title, subTitle, butttonText, resultIcon, closable } = getResult(result);

    return (
        <div className="dialog-docked">
            <div className={clsx('lucky-wheel-result-container p-abs flex flex-col items-center', { mobile: onPhone })}>
                <div className="lucky-wheel-result text-center">
                    <div className="lucky-wheel-result-icon mb-20">{resultIcon}</div>
                    <h1 className="title fs-24 uppercase mb-10 text-extra-bold">{title}</h1>
                    <h2
                        className="text-normal c-black-50-2 mb-30 fs-16"
                        dangerouslySetInnerHTML={{ __html: subTitle }}
                    ></h2>
                </div>
                <div className="lucky-wheel-button-container flex flex-col justify-center items-center">
                    {butttonText ? (
                        <>
                            <Button
                                primary
                                className="nui-button-max-300 mb-0"
                                label={butttonText}
                                onClick={actionButtonClick}
                            />
                            {closable ? (
                                <div className="mt-20">
                                    <a className="nui-blue-link pointer text text-center" onClick={handleClose}>
                                        {i18n('nui.tournament.daily.limit.modal.button')}
                                    </a>
                                </div>
                            ) : null}
                        </>
                    ) : (
                        <Button
                            primary
                            className="nui-button-max-300 mb-0"
                            label={i18n('nui.tournament.daily.limit.modal.button')}
                            onClick={handleClose}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default LuckyWheelResult;
